import axios from "axios";
import "./UserNotification.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useQuery } from 'react-query';
import moment from 'moment-timezone';
import { getAllISOCodes } from 'iso-country-currency';
import currencyCodes from "currency-codes";
import userTypeName from "../../../../constants/userType";
import Add from "../../../../images/icons/plus-icon.svg";
import Delete from "../../../../images/icons/delete.svg";
import userCategoryName from "../../../../constants/userCategory";
import { logout, reset } from "../../../../features/auth/authSlice";
import { toggleNotification } from '../../../../features/auth/authSlice';
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { setNotification } from "../../../../features/notification/notificationSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";
import { setAppSettings } from "../../../../features/appSettings/appSettingsSlice.js";
import { useTimeZone } from "../../../TimeTracker/Timer/tracker/TimerDataApi.jsx";
import userCategory from "../../../../constants/userCategory";
import { useUserSettings } from "../../../../features/users/useUserSettings.jsx";

const UserNotification = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isNotificationLoading, setIsNotificationLoading] = useState(false);
    const [isEmailNotificationLoading, setIsEmailNotificationLoading] = useState(false);
    const [isAdminTimeoffEmailNotificationLoading, setIsAdminTimeoffEmailNotificationLoading] = useState(false);
    const [isAdminInvoiceEmailNotificationLoading, setIsAdminInvoiceEmailNotificationLoading] = useState(false);
    const [userView, setUserView] = useState([]);
    const user = useSelector((state) => state.auth.user);
    // const [data, setData] = useState([]);
    // const [dataLoading, setDataLoading] = useState(false);
    const [timeZoneSearchTerm, setTimeZoneSearchTerm] = useState('');
    const [timeZones, setTimeZones] = useState([]);
    const [currencySearchTerm, setCurrencySearchTerm] = useState('');
    const [currencies, setCurrencies] = useState([]);
    const [currencyDropdownOpen, setCurrencyDropdownOpen] = useState(false);
    const [timeFormatDropdownOpen, settimeFormatDropdownOpen] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [timeFormat, setTimeFormat] = useState(null);
    const currencyDropdownRef = useRef(null);
    const timeFormatDropdownRef = useRef(null);
    const [timezoneDropdownOpen, setTimezoneDropdownOpen] = useState(false);
    const [selectedTimezone, setSelectedTimezone] = useState(null);
    const timezoneDropdownRef = useRef(null);
    const [isGoogleCalendarIntegrationStatusLoading, setIsGoogleCalendarIntegrationStatusLoading] = useState(false);
    const [isGoogleCalendarEnabled, setIsGoogleCalendarEnabled] = useState(false);
    const [isMicrosoftCalendarEnabled, setIsMicrosoftCalendarEnabled] = useState(false);
    const [isMicrosoftCalendarIntegrationStatusLoading, setIsMicrosoftCalendarIntegrationStatusLoading] = useState(false);
    const [timeStamp, setTimestamp] = useState(null);
    const [googleAccountEmail, setGoogleAccountEmail] = useState(null);
    const [isGoogleAccountLoading, setIsGoogleAccountLoading] = useState(false);
    const [googleAccountError, setGoogleAccountError] = useState(null);
    const [microsoftAccountEmail, setMicrosoftAccountEmail] = useState(null);
    const [isMicrosoftAccountLoading, setIsMicrosoftAccountLoading] = useState(false);
    const [microsoftAccountError, setMicrosoftAccountError] = useState(null);
    const { appSettings } = useSelector((state) => state.appSettings);
    let token = null;
    if (user) {
        if (user && user.token) {
            token = user.token;
        }
    }
    const userEmail = user && user.email;
    let userId = user && user._id;

    const { data: timeZoneData = [], isLoading: isTimeZoneDataLoading, refetch: refetchTimeZoneDatas, isError: timeZoneDataError } = useTimeZone(props && props.id, token);
    const { data: userSettingsData = [], isLoading: userSettingsLoading, refetch: refetchUserSettingData } = useUserSettings(props && props.id, token,);

    // const fetchData = async () => {
    //     try {
    //         setDataLoading(true); // Set loading to true before making the request
    //         const response = await axios.get(
    //             `/api/get/user-settings/${props.id}`,
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 },
    //             }
    //         );
    //         setData(response.data);
    //     } catch (error) {
    //         console.log("Error", error);
    //         global.config.slackMessage(error.toString());
    //     } finally {
    //         setDataLoading(false); // Set loading to false after the request is completed
    //     }
    // };

    // const { data, isLoading: dataLoading, error, refetch } = useQuery('exampleQueryKey', fetchData);

    // useEffect(() => {
    //     setSelectedCurrency(timeZoneData && timeZoneData.currency);
    //     setSelectedTimezone(timeZoneData && timeZoneData.timeZone);
    //     setTimeFormat(timeZoneData && timeZoneData.timeFormat);
    // }, [timeZoneData]);

    useEffect(() => {
        const updateTimeZoneData = async () => {
            // Use setTimeout to ensure it doesn't block the main thread
            setTimeout(() => {
                if (timeZoneData) {
                    setSelectedCurrency(timeZoneData.currency);
                    setSelectedTimezone(timeZoneData.timeZone);
                    setTimeFormat(timeZoneData.timeFormat);
                }
            }, 0); // run asynchronously after the current execution context
        };

        updateTimeZoneData();
    }, [timeZoneData]);

    useEffect(() => {
        const checkGoogleCalendarStatus = async () => {
            if (!userEmail || !token) return;
            try {
                const response = await axios.post(
                    '/api/google-calendar/validate-email',
                    { email: userEmail },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setIsGoogleCalendarEnabled(response.data.exists);
            } catch (error) {
                console.error('Error checking Google Calendar status:', error);
                setIsGoogleCalendarEnabled(false);
            }
        };
        const checkMicrosoftCalendarStatus = async () => {
            if (!userEmail || !token) return;
            try {
                const response = await axios.post(
                    '/api/microsoft-calendar/validate-email',
                    { email: userEmail },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setIsMicrosoftCalendarEnabled(response.data.exists);
            } catch (error) {
                console.error('Error checking Microsoft Calendar status:', error);
                setIsMicrosoftCalendarEnabled(false);
            }
        }
        checkGoogleCalendarStatus();
        checkMicrosoftCalendarStatus();
    }, [userEmail, token]);

    useEffect(() => {
        const fetchGoogleAccountDetails = async () => {
            if (!userEmail || !token || !isGoogleCalendarEnabled || !userSettingsData?.user_google_calendar_enabled) return;

            setIsGoogleAccountLoading(true);
            setGoogleAccountError(null);

            try {
                const response = await axios.post(
                    '/api/google-calendar/get-account-details',
                    { email: userEmail },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.data) {
                    setGoogleAccountEmail(response.data.accounts);
                } else {
                    setGoogleAccountEmail(null);
                    setGoogleAccountError('No Google account details found');
                }
            } catch (error) {
                console.error('Error fetching Google account details:', error);
                setGoogleAccountEmail(null);
                setGoogleAccountError(null);
            } finally {
                setIsGoogleAccountLoading(false);
            }
        };

        const fetchMicrosoftAccountDetails = async () => {
            if (!userEmail || !token || !isMicrosoftCalendarEnabled || !userSettingsData?.user_microsoft_calendar_enabled || !user?._id) return;

            setIsMicrosoftAccountLoading(true);
            setMicrosoftAccountError(null);

            try {
                const response = await axios.post(
                    '/api/microsoft-calendar/get-account-details',
                    { email: userEmail },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.data) {
                    setMicrosoftAccountEmail(response.data.userDetails);
                } else {
                    setMicrosoftAccountEmail(null);
                    setMicrosoftAccountError('No Microsoft account details found');
                }
            } catch (error) {
                console.error('Error fetching Microsoft account details:', error);
                setMicrosoftAccountEmail(null);
                setMicrosoftAccountError(null);
            } finally {
                setIsMicrosoftAccountLoading(false);
            }
        };

        fetchGoogleAccountDetails();
        fetchMicrosoftAccountDetails();
    }, [timeStamp, userEmail, token, isGoogleCalendarEnabled, userSettingsData?.user_google_calendar_enabled, isMicrosoftCalendarEnabled, userSettingsData?.user_microsoft_calendar_enabled, user?._id]);

    // useEffect(() => {
    //     refetchTimeZoneDatas();
    // }, [selectedCurrency, selectedTimezone, props.id]);

    useEffect(() => {
        const fetchTimeZoneDataAsync = async () => {
            try {
                // Call your refetch function asynchronously
                await refetchTimeZoneDatas();
            } catch (error) {
                console.error('Error fetching timezone data:', error);
            }
        };

        fetchTimeZoneDataAsync();
    }, [selectedCurrency, selectedTimezone, props.id]);

    const toggleCurrencyDropdown = () => {
        setCurrencyDropdownOpen(!currencyDropdownOpen);
    };
    const toggleTimeFormatDropdown = () => {
        settimeFormatDropdownOpen(!timeFormatDropdownOpen);
    };
    // let userId = null;
    const selectTimeFormat = async (selectedFormat) => {
        setTimeFormat(selectedFormat);
        if (user._id === props.id) {
            const updatedSettings = { ...appSettings, timeFormat: selectedFormat };
            await dispatch(setAppSettings(updatedSettings));
            userId = user._id;
        } else {
            userId = props.id;
        }

        settimeFormatDropdownOpen(false);
        try {
            const response = await axios.post(
                `/api/post/admin/user-settings`,
                {
                    timeZone: null,
                    currency: null,
                    language: null,
                    timerLock: null,
                    timerLockTime: null,
                    seoTitle: null,
                    metaDescription: null,
                    weekStartDay: null,
                    appId: props.id,
                    userId: userId,
                    timeFormat: selectedFormat
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success("Settings updated successfully", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            localStorage.removeItem('zoneChangeConfirm');
        } catch (error) {
            console.log(error);
            global.config.slackMessage(error.toString());
        }

    }
    const selectCurrencyOption = async (selectedCurrency) => {
        setSelectedCurrency(selectedCurrency);
        if (user._id === props.id) {
            const updatedSettings = { ...appSettings, currency: selectedCurrency };
            await dispatch(setAppSettings(updatedSettings));
            userId = user._id;
        } else {
            userId = props.id;
        }

        setCurrencyDropdownOpen(false);
        try {
            const response = await axios.post(
                `/api/post/admin/user-settings`,
                {
                    timeZone: null,
                    currency: selectedCurrency,
                    language: null,
                    timerLock: null,
                    timerLockTime: null,
                    seoTitle: null,
                    metaDescription: null,
                    weekStartDay: null,
                    userId: userId,
                    timeFormat: null
                    // appId: props.id,

                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        } catch (error) {
            console.log(error);
            global.config.slackMessage(error.toString());
        }

        toast.success("Settings updated successfully", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const toggleTimezoneDropdown = () => {
        setTimezoneDropdownOpen(!timezoneDropdownOpen);
    };

    const selectTimezoneOption = async (selectedTimezone) => {

        // console.log(selectedTimezone,props);
        setSelectedTimezone(selectedTimezone);
        let userId = null;
        if (user._id === props.id) {
            const updatedSettings = { ...appSettings, timeZone: selectedTimezone };
            await dispatch(setAppSettings(updatedSettings));
            userId = user._id;
        } else {
            userId = props.id;
        }
        setTimezoneDropdownOpen(false);
        try {
            const response = await axios.post(
                `/api/post/admin/user-settings`,
                {
                    timeZone: selectedTimezone,
                    currency: null,
                    language: null,
                    timerLock: null,
                    timerLockTime: null,
                    seoTitle: null,
                    metaDescription: null,
                    weekStartDay: null,
                    // appId: props.id,
                    userId: userId,
                    timeFormat: null
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success("Settings updated successfully", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            localStorage.removeItem('zoneChangeConfirm');
            window.location.reload();
        } catch (error) {
            console.log(error);
            global.config.slackMessage(error.toString());
        }
    };

    // useEffect(() => {

    //     async function fetchUser() {
    //         setIsLoading(true);
    //         try {
    //             const response = await axios.get(`/api/user/view/${props.id}`, {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 },
    //             });
    //             setUserView(response.data);

    //             setIsLoading(false);
    //         } catch (error) {
    //             console.log(error);
    //             global.config.slackMessage(error.toString());
    //             if (error.response?.data?.status === "deleted") {
    //                 localStorage.removeItem("user");
    //                 dispatch(logout());
    //                 dispatch(reset());
    //                 dispatch(invoiceReset());
    //                 dispatch(headerReset());
    //                 dispatch(appSettingsReset());
    //                 toast.error('This user is deleted!', {
    //                     position: "bottom-right",
    //                     autoClose: 1500,
    //                     hideProgressBar: false,
    //                     closeOnClick: true,
    //                     pauseOnHover: true,
    //                     draggable: true,
    //                     progress: undefined,
    //                     theme: "light",
    //                 });
    //                 navigate("/");
    //                 return;
    //             }
    //             alert("Something went wrong in fetching users");
    //         }
    //     }

    //     fetchUser().then(() => { });
    // }, [props.id]);


    useEffect(() => {
        const fetchUser = async () => {
            setIsLoading(true);
            try {
                const response = await axios.get(`/api/user/view/${props.id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUserView(response.data);
            } catch (error) {
                console.log(error);
                global.config.slackMessage(error.toString());
                if (error.response?.data?.status === "deleted") {
                    localStorage.removeItem("user");
                    dispatch(logout());
                    dispatch(reset());
                    dispatch(invoiceReset());
                    dispatch(headerReset());
                    dispatch(appSettingsReset());
                    toast.error('This user is deleted!', {
                        position: "bottom-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    navigate("/");
                    return;
                }
                alert("Something went wrong in fetching users");
            } finally {
                setIsLoading(false);
            }
        };

        fetchUser();
    }, [props.id]);


    // useEffect(() => {
    //     const fetchTimeZones = () => {
    //         // Get the time zone names using the Intl.DateTimeFormat object
    //         const allTimeZones = moment.tz.names();
    //         const allCurrencies = getAllISOCodes();

    //         // Set the time zones in the state
    //         setTimeZones(allTimeZones);
    //         setCurrencies(allCurrencies);
    //     };

    //     // Call the fetchTimeZones function
    //     fetchTimeZones();
    // }, []);

    useEffect(() => {
        const fetchTimeZones = async () => {
            // Use a non-blocking approach for fetching time zones
            const allTimeZones = await new Promise((resolve) => {
                setTimeout(() => {
                    resolve(moment.tz.names()); // Simulate async behavior if necessary
                }, 0);
            });
            const allCurrencies = getAllISOCodes();
            // Update the state in a non-blocking manner
            setTimeZones(allTimeZones);
            setCurrencies(allCurrencies);
        };

        // Call the fetchTimeZones function
        fetchTimeZones();
    }, []);

    const handleCurrencyFilterChange = (e) => {
        setCurrencySearchTerm(e.target.value);
    };

    const codeToCurrency = (code) => {
        var currencyCode = code ? code : 'USD';
        try {
            var currencyCode1 = currencyCodes.code(currencyCode).currency;
            return currencyCode1.toString(); // Ensure it's a string
        } catch (error) {
            return code.toString(); // Ensure it's a string
        }
    }

    const filteredCurrencies = currencies.filter((currency) => {
        const currencyName = codeToCurrency(currency.currency && currency.currency);
        return currencyName.toLowerCase().includes(currencySearchTerm.toLowerCase());
    });

    const handleTimeZoneFilterChange = (e) => {
        setTimeZoneSearchTerm(e.target.value);
    };

    const filteredTimeZone = timeZones.filter((timeZone) => {
        return timeZone.toLowerCase().includes(timeZoneSearchTerm.toLowerCase());
    });

    const handleClickOutsideDropdown = (event) => {
        const isClickInsideTimezoneDropdown = timezoneDropdownRef.current && timezoneDropdownRef.current.contains(event.target);
        const isClickInsideCurrencyDropdown = currencyDropdownRef.current && currencyDropdownRef.current.contains(event.target);
        const isClickInsideTimeFormatDropdown = timeFormatDropdownRef.current && timeFormatDropdownRef.current.contains(event.target);

        if (!isClickInsideTimezoneDropdown) {
            setTimezoneDropdownOpen(false);
        }
        if (!isClickInsideCurrencyDropdown) {
            setCurrencyDropdownOpen(false);
        }
        if (!isClickInsideTimeFormatDropdown) {

            settimeFormatDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutsideDropdown);
        return () => {
            document.removeEventListener('click', handleClickOutsideDropdown);
        };
    }, []);

    const handleEnableEmailNotificationChange = async (id) => {
        try {
            setIsEmailNotificationLoading(true);
            const response = await axios.get(`/api/user/email/notification/status-change/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success(`${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s email notification status updated successfully`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s email notification status updated successfully`
            );
            dispatch(setNotification(Date.now()));
            setUserView((prevState) => {
                // Find the user object with the corresponding id
                if (prevState._id === id) {
                    // Update the is_active property of the user object
                    return { ...prevState, is_email_enabled: !prevState.is_email_enabled };
                }
                return prevState;
            });
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            toast.error("Something went wrong in changing user status!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `Something went wrong while changing ${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s Email Notification Status`
            );
            console.log(error);
        } finally {
            setIsEmailNotificationLoading(false);
        }
    };

    const handleEnableAdminTimeoffEmailNotificationChange = async (id) => {
        try {
            setIsAdminTimeoffEmailNotificationLoading(true);
            const response = await axios.get(`/api/admin/user/time-off/email/notification/status-change/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success(`Admin "${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s" time off email notification status updated successfully`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `Admin "${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s" time off email notification status updated successfully`
            );
            dispatch(setNotification(Date.now()));
            setUserView((prevState) => {
                // Find the user object with the corresponding id
                if (prevState._id === id) {
                    // Update the is_active property of the user object
                    return { ...prevState, is_admin_timeoff_email_enabled: !prevState.is_admin_timeoff_email_enabled };
                }
                return prevState;
            });
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            toast.error("Something went wrong in changing admin email status!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `Something went wrong while changing Admin "${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s" time off email notification status`
            );
            console.log(error);
        } finally {
            setIsAdminTimeoffEmailNotificationLoading(false);
        }
    };

    const handleEnableAdminInvoiceEmailNotificationChange = async (id) => {
        try {
            setIsAdminInvoiceEmailNotificationLoading(true);
            const response = await axios.get(`/api/admin/user/invoice/email/notification/status-change/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success(`Admin "${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s" invoice email notification status updated successfully`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `Admin "${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s" Invoice email notification status updated successfully`
            );
            dispatch(setNotification(Date.now()));
            setUserView((prevState) => {
                // Find the user object with the corresponding id
                if (prevState._id === id) {
                    // Update the is_active property of the user object
                    return { ...prevState, is_admin_invoice_email_enabled: !prevState.is_admin_invoice_email_enabled };
                }
                return prevState;
            });
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            toast.error("Something went wrong in changing admin email status!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `Something went wrong while changing Admin "${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s" Invoice Email Notification Status`
            );
            console.log(error);
        } finally {
            setIsAdminInvoiceEmailNotificationLoading(false);
        }
    };

    const handleEnableNotificationChange = async (id) => {
        try {
            setIsNotificationLoading(true);
            await axios.get(`/api/user/notification/status-change/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success(`${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s notification status updated successfully`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s notification status updated successfully`
            );
            if (user._id === id) {
                dispatch(toggleNotification());
            }
            dispatch(setNotification(Date.now()));
            setUserView((prevState) => {
                if (prevState._id === id) {
                    return { ...prevState, is_notification_enabled: !prevState.is_notification_enabled };
                }
                return prevState;
            });
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            toast.error("Something went wrong in changing user notification status!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `Something went wrong while changing ${userView && userView.user_category && [userCategoryName.Business, userCategoryName.Vendor, userCategoryName.Client].includes(userView.user_category) ? userView.company_name : userView.first_name}'s Notification Status`
            );
            console.log(error);
        } finally {
            setIsNotificationLoading(false);
        }
    };

    const handleEnableGoogleCalendarIntegrationChange = async (id) => {
        try {
            setIsGoogleCalendarIntegrationStatusLoading(true);
            const response = await axios.get(`/api/user-settings/google-calendar/integration/status-change/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const isEnabled = response.data.data.user_google_calendar_enabled;

            if (!isEnabled && isGoogleCalendarEnabled) {
                try {
                    await axios.post(
                        '/api/google-calendar/disable',
                        { email: userEmail },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    setIsGoogleCalendarEnabled(false);
                    toast.success("Google Calendar integration disabled successfully", {
                        position: "bottom-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } catch (disableError) {
                    console.error('Error disabling Google Calendar integration:', disableError);
                    toast.error("Failed to disable Google Calendar integration", {
                        position: "bottom-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                    await axios.get(`/api/user-settings/google-calendar/integration/status-change/${id}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    }); // Re-enable to sync with backend
                    setIsGoogleCalendarEnabled(true);
                    return;
                }
            }

            toast.success(`Google Calendar integration ${isEnabled ? 'enabled' : 'disabled'} successfully`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `User "${id}'s" Google Calendar integration ${isEnabled ? 'enabled' : 'disabled'} successfully`
            );
            refetchUserSettingData();
            dispatch(setNotification(Date.now()));
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            toast.error("Something went wrong in changing Google Calendar integration status!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `Something went wrong while changing user "${id}'s" Google Calendar integration status!`
            );
            console.log(error);
        } finally {
            setIsGoogleCalendarIntegrationStatusLoading(false);
        }
    };

    // const handleGoogleCalendarToggle = async () => {
    //     if (!isGoogleCalendarEnabled) {
    //         const origin = window.location.origin;
    //         const baseUrl = window.location.origin.includes("localhost:3000")
    //             ? "http://localhost:8090"
    //             : window.location.origin;
    //         const url = `${baseUrl}/google?origin=${encodeURIComponent(origin)}&userId=${encodeURIComponent(userId)}`;
    //         if (origin && userId) {
    //             window.open(url, '_self');
    //         } else {
    //             toast.error("Missing origin or user ID", {
    //                 position: "bottom-right",
    //                 autoClose: 2000,
    //             });
    //         }
    //     }
    // };

    const handleMoreGoogleCalendarToggle = async () => {
        const origin = `${window.location.origin}/user/profile/settings`;
        const baseUrl = window.location.origin.includes("localhost:3000")
            ? "http://localhost:8090"
            : window.location.origin;
        const url = `${baseUrl}/google?origin=${encodeURIComponent(origin)}&userId=${encodeURIComponent(userId)}`;
        if (origin && userId) {
            window.open(url, '_self');
        } else {
            toast.error("Missing redirect URL or user ID", {
                position: "bottom-right",
                autoClose: 2000,
            });
        }
    };

    const handleRemoveGoogleAccount = async (accountId) => {
        if (!accountId) return;
        try {
            await axios.delete(`/api/google-calendar/delete-account/${accountId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setGoogleAccountEmail((prev) => prev.filter(acc => acc._id !== accountId));
            setTimestamp(Date.now());
            toast.success('Account removed successfully', {
                position: "bottom-right",
                autoClose: 2000,
            });
        } catch (error) {
            console.error('Error deleting Google account:', error);
            toast.error('Failed to remove account', {
                position: "bottom-right",
                autoClose: 2000,
            });
        }
    };

    const handleEnableMicrosoftCalendarIntegrationChange = async (id) => {
        try {
            setIsMicrosoftCalendarIntegrationStatusLoading(true);
            const response = await axios.get(`/api/user-settings/microsoft-calendar/integration/status-change/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const isEnabled = response.data.data.user_microsoft_calendar_enabled;

            if (!isEnabled && isMicrosoftCalendarEnabled) {
                try {
                    await axios.post(
                        '/api/microsoft-calendar/disable',
                        { email: userEmail },
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    setIsMicrosoftCalendarEnabled(false);
                    toast.success("Microsoft Calendar integration disabled successfully", {
                        position: "bottom-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } catch (disableError) {
                    console.error('Error disabling Microsoft Calendar integration:', disableError);
                    toast.error("Failed to disable Microsoft Calendar integration", {
                        position: "bottom-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                    await axios.get(`/api/user-settings/microsoft-calendar/integration/status-change/${id}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    }); // Re-enable to sync with backend
                    setIsMicrosoftCalendarEnabled(true);
                    return;
                }
            }

            toast.success(`Microsoft Calendar integration ${isEnabled ? 'enabled' : 'disabled'} successfully`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `User "${id}'s" Microsoft Calendar integration ${isEnabled ? 'enabled' : 'disabled'} successfully`
            );
            refetchUserSettingData();
            dispatch(setNotification(Date.now()));
        } catch (error) {
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            toast.error("Something went wrong in changing Microsoft Calendar integration status!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            global.config.activityLog(
                window.location.href,
                "User",
                `Something went wrong while changing user "${id}'s" Microsoft Calendar integration status!`
            );
            console.log(error);
        } finally {
            setIsMicrosoftCalendarIntegrationStatusLoading(false);
        }
    };

    const handleMicrosoftCalendarToggle = async () => {
        //if (!isMicrosoftCalendarEnabled) {
        const redirectUrl = `${window.location.origin}/user/profile/settings`;
        const baseUrl = window.location.origin.includes("localhost:3000")
            ? "http://localhost:8090"
            : window.location.origin;
        const url = `${baseUrl}/microsoft?redirectUrl=${encodeURIComponent(redirectUrl)}&userId=${encodeURIComponent(userId)}`;
        if (redirectUrl && userId) {
            window.open(url, '_self');
        } else {
            toast.error("Missing redirect URL or user ID", {
                position: "bottom-right",
                autoClose: 2000,
            });
        }
        //}
    };

    const handleRemoveMicrosoftAccount = async (accountId) => {
        if (!accountId) return;
        try {
            // Adjust if stored differently
            await axios.delete(`/api/microsoft-calendar/delete-account/${accountId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            // Refresh state after deletion
            setMicrosoftAccountEmail((prev) => prev.filter(acc => acc._id !== accountId));
            setTimestamp(Date.now()); // Trigger re-fetch of accounts
            toast.success('Account removed successfully', {
                position: "bottom-right",
                autoClose: 2000,
            });
        } catch (error) {
            console.error('Error deleting Microsoft account:', error);
            toast.error('Failed to remove account');
        }
    };

    return (
        <div>
            {/* <div className="security-outer noti-outer">
                        <div className="security-inner noti-enable noti-head-noti">
                            <span className="custom-switch-description">Notifications</span>
                            <div className="toggle-spinner">

                            </div>
                        </div>

                        <div className="security-inner noti-enable">
                            <span className="custom-switch-description">
                                Enable all in-app notifications
                            </span>
                            <div className="toggle-spinner">
                                {isLoading === true && (

                                    <ThreeDots
                                        height="18"
                                        width="20"
                                        radius="9"
                                        color="#6479f9"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClassName=""
                                        visible={true}
                                    />
                                )}

                                {isNotificationLoading === true && (

                                    <ThreeDots
                                        height="18"
                                        width="20"
                                        radius="9"
                                        color="#6479f9"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClassName=""
                                        visible={true}
                                    />)}

                                {isLoading === false && (
                                    <label className="custom-switch">
                                        <input
                                            type="checkbox"
                                            className="custom-switch-input"
                                            id="emailnotification"
                                            name="enable_emailnotification"
                                            value="1"
                                            style={{ cursor: "pointer" }}
                                            checked={userView.is_notification_enabled === true}
                                            onChange={() => handleEnableNotificationChange(userView._id)}
                                        />
                                        <span style={{ cursor: "pointer" }} className="custom-switch-slider"></span>
                                    </label>)}
                            </div>
                        </div>
                        <div className="security-inner noti-enable">
                            <span className="custom-switch-description">
                                Enable all email notification
                            </span>
                            <div className="toggle-spinner">
                                {isLoading === true && (

                                    <ThreeDots
                                        height="18"
                                        width="20"
                                        radius="9"
                                        color="#6479f9"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClassName=""
                                        visible={true}
                                    />
                                )}

                                {isEmailNotificationLoading === true && (

                                    <ThreeDots
                                        height="18"
                                        width="20"
                                        radius="9"
                                        color="#6479f9"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{}}
                                        wrapperClassName=""
                                        visible={true}
                                    />)}
                                {isLoading === false && (
                                    <label className="custom-switch">
                                        <input
                                            type="checkbox"
                                            className="custom-switch-input"
                                            id="emailnotification"
                                            name="enable_emailnotification"
                                            value="1"
                                            checked={userView.is_email_enabled === true}
                                            onChange={() => handleEnableEmailNotificationChange(userView._id)}
                                        />
                                        <span style={{ cursor: "pointer" }} className="custom-switch-slider"></span>
                                    </label>)}
                            </div>
                        </div>
                        {(userView?.role_id?._id === userTypeName.Super_Admin || userView?.role_id?._id === userTypeName.Admin) &&
                            <>
                                <div className="security-inner noti-enable">
                                    <span className="custom-switch-description">
                                        Enable TimeOff email notification
                                    </span>
                                    <div className="toggle-spinner">
                                        {isLoading === true && (

                                            <ThreeDots
                                                height="18"
                                                width="20"
                                                radius="9"
                                                color="#6479f9"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={true}
                                            />
                                        )}

                                        {isAdminTimeoffEmailNotificationLoading === true && (

                                            <ThreeDots
                                                height="18"
                                                width="20"
                                                radius="9"
                                                color="#6479f9"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={true}
                                            />)}
                                        {isLoading === false && (
                                            <label className="custom-switch">
                                                <input
                                                    type="checkbox"
                                                    className="custom-switch-input"
                                                    id="emailnotification"
                                                    name="enable_emailnotification"
                                                    value="1"
                                                    checked={userView.is_admin_timeoff_email_enabled === true}
                                                    onChange={() => handleEnableAdminTimeoffEmailNotificationChange(userView._id)}
                                                />
                                                <span style={{ cursor: "pointer" }} className="custom-switch-slider"></span>
                                            </label>)}
                                    </div>
                                </div>
                                <div className="security-inner noti-enable">
                                    <span className="custom-switch-description">
                                        Enable Invoice email notification
                                    </span>
                                    <div className="toggle-spinner">
                                        {isLoading === true && (
                                            <ThreeDots
                                                height="18"
                                                width="20"
                                                radius="9"
                                                color="#6479f9"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={true}
                                            />
                                        )}

                                        {isAdminInvoiceEmailNotificationLoading === true && (
                                            <ThreeDots
                                                height="18"
                                                width="20"
                                                radius="9"
                                                color="#6479f9"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={true}
                                            />)}
                                        {isLoading === false && (
                                            <label className="custom-switch">
                                                <input
                                                    type="checkbox"
                                                    className="custom-switch-input"
                                                    id="emailnotification"
                                                    name="enable_emailnotification"
                                                    value="1"
                                                    checked={userView.is_admin_invoice_email_enabled === true}
                                                    onChange={() => handleEnableAdminInvoiceEmailNotificationChange(userView._id)}
                                                />
                                                <span style={{ cursor: "pointer" }} className="custom-switch-slider"></span>
                                            </label>)}
                                    </div>
                                </div>
                            </>
                        }
                    </div> */}

            <div className="security-outer noti-outer profile-edit-profile">
                <div className="security-inner noti-enable noti-head-noti">
                    <span className="custom-switch-description">Profile</span>
                    <div className="toggle-spinner">

                    </div>
                </div>

                {(user && (user.userCategory !== userCategory.Vendor) && (user.userCategory !== userCategory.Client)) && (
                    <div className="security-inner noti-enable">
                        <span className="custom-switch-description">
                            Default Timezone
                        </span>
                        <div className="custom-dropdown">
                            {isTimeZoneDataLoading ? (
                                <div className="custom-dropdown-user-new-outer">
                                    <div
                                        className="selected-option custom-dropdown-user-new"
                                        style={{
                                            backgroundColor: "#e5e7eb",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: "150px",
                                                height: "20px",
                                                backgroundColor: "#cbd5e1",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div ref={timezoneDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${timezoneDropdownOpen ? 'open' : ''}`}>
                                    <div className="selected-option custom-dropdown-user-new" onClick={toggleTimezoneDropdown}>
                                        {selectedTimezone ? selectedTimezone : 'Select Timezone'}
                                    </div>
                                    {timezoneDropdownOpen && (
                                        <div className="custom-dropdown-new">
                                            <input
                                                type="text"
                                                className="search-bar"
                                                placeholder="Search Timezone"
                                                value={timeZoneSearchTerm}
                                                onChange={handleTimeZoneFilterChange}
                                            />
                                            <ul className="type-list">
                                                {filteredTimeZone.sort((a, b) => a.localeCompare(b)).map((timeZone, index) => (
                                                    <li onClick={() => selectTimezoneOption(timeZone)} key={index}>{timeZone}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <div className="security-inner noti-enable">
                    <span className="custom-switch-description">
                        Default currency
                    </span>
                    <div className="custom-dropdown">
                        {isTimeZoneDataLoading ? (
                            <div className="custom-dropdown-user-new-outer">
                                <div
                                    className="selected-option custom-dropdown-user-new"
                                    style={{
                                        backgroundColor: "#e5e7eb",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                        pointerEvents: "none",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "150px",
                                            height: "20px",
                                            backgroundColor: "#cbd5e1",
                                            borderRadius: "4px",
                                        }}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div ref={currencyDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${currencyDropdownOpen ? 'open' : ''}`}>
                                <div className="selected-option custom-dropdown-user-new" onClick={toggleCurrencyDropdown}>
                                    {selectedCurrency ? selectedCurrency : 'Select Currency'}
                                </div>
                                {currencyDropdownOpen && (
                                    <div className="custom-dropdown-new">
                                        <input
                                            type="text"
                                            className="search-bar"
                                            placeholder="Search Currency"
                                            value={currencySearchTerm}
                                            onChange={handleCurrencyFilterChange}
                                        />
                                        <ul className="type-list">
                                            {filteredCurrencies
                                                .reduce((uniqueCurrencies, currency) => {
                                                    const currencyName = codeToCurrency(currency.currency && currency.currency);
                                                    if (!uniqueCurrencies.find(item => item.name === currencyName)) {
                                                        uniqueCurrencies.push({ name: currencyName, currency: currency.currency }); // Push the currency object along with its name
                                                    }
                                                    return uniqueCurrencies;
                                                }, [])
                                                .sort((a, b) => a.name.localeCompare(b.name))
                                                .map((currency, index) => (
                                                    <li onClick={() => selectCurrencyOption(currency.currency)} key={index}>
                                                        {currency.name}
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {(user && (user.userCategory !== userCategory.Vendor) && (user.userCategory !== userCategory.Client)) && (
                    <div className="security-inner noti-enable">
                        <span className="custom-switch-description">
                            Time Format
                        </span>
                        <div className="custom-dropdown">
                            {isTimeZoneDataLoading ? (
                                <div className="custom-dropdown-user-new-outer">
                                    <div
                                        className="selected-option custom-dropdown-user-new"
                                        style={{
                                            backgroundColor: "#e5e7eb",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: "150px",
                                                height: "20px",
                                                backgroundColor: "#cbd5e1",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div ref={timeFormatDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${timeFormatDropdownOpen ? 'open' : ''}`}>
                                    <div className="selected-option custom-dropdown-user-new" onClick={toggleTimeFormatDropdown}>
                                        {timeFormat ? `${timeFormat} Hours` : 'Select Format'}
                                    </div>
                                    {timeFormatDropdownOpen && (
                                        <div className="custom-dropdown-new">
                                            <ul className="type-list">
                                                <li
                                                    onClick={() => selectTimeFormat(24)}
                                                    key="1"
                                                >
                                                    24 Hours
                                                </li>
                                                <li
                                                    onClick={() => selectTimeFormat(12)}
                                                    key="2"
                                                >
                                                    12 Hours
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {(user && (user.userCategory !== userCategory.Vendor) && (user.userCategory !== userCategory.Client)) && (
                <div className="security-outer noti-outer tracker-settings">
                    <div className="security-inner noti-enable noti-head-noti">
                        <span className="custom-switch-description">
                            {global.config.locate(appSettings && appSettings.language, 'Calendar_Integrations')}
                        </span>
                    </div>
                    {/* {userSettingsData?.user_google_calendar_enabled && ( */}
                    <div className="security-inner noti-enable security-inner-new">
                        <span className="custom-switch-description">
                            {global.config.locate(appSettings && appSettings.language, 'Connect_your_Google_Calendar')}
                        </span>
                        <div className="accordion-right">
                            {userSettingsLoading === true ? (
                                <div className="button-sec-account" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                    <div
                                        style={{
                                            width: "120px",
                                            height: "20px",
                                            backgroundColor: "#e5e7eb",
                                            borderRadius: "4px",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                        }}
                                    />
                                </div>
                            ) : (
                                <div className="button-sec-account">
                                    {isGoogleCalendarEnabled && (
                                        <div className="google-account-email">
                                            {isGoogleAccountLoading ? (
                                                <div className="connected-to-new">
                                                    <div className="new-connect-wrapper">
                                                        <div
                                                            style={{
                                                                width: "200px",
                                                                height: "44px",
                                                                backgroundColor: "#e5e7eb",
                                                                borderRadius: "8px",
                                                                animation: "pulse 1.5s ease-in-out infinite",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            ) : googleAccountError ? (
                                                <span className="error-text">{googleAccountError}</span>
                                            ) : googleAccountEmail ? (
                                                googleAccountEmail?.length > 0 && (
                                                    <>
                                                        <div className="connected-to-new">
                                                            {googleAccountEmail.map((account, index) => (
                                                                <div key={index} className="new-connect-wrapper">
                                                                    <div className="new-connected">
                                                                        Connected to {account.email}
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                                                                            <path d="M1 4.5L5 8.5L12.5 1" stroke="#70AD69" strokeWidth="1.5" />
                                                                        </svg>
                                                                    </div>
                                                                    <div className="new-disconnect">
                                                                        <a
                                                                            className="remove-account-sync"
                                                                            onClick={() => handleRemoveGoogleAccount(account.account_id)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                                                                <path d="M13.7886 4.59619L4.59619 13.7886" stroke="#6A7988" strokeWidth="1.5" />
                                                                                <path d="M13.7886 13.7886L4.59619 4.59619" stroke="#6A7988" strokeWidth="1.5" />
                                                                            </svg>
                                                                            Disconnect
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* <div className="connect-label">Connected account:</div>
                                                            <div className="connected-google-accounts">

                                                                {googleAccountEmail.map((account, index) => (
                                                                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                                                        <img
                                                                            src={account.picture}
                                                                            alt={account.email}
                                                                            style={{ width: '24px', height: '24px', borderRadius: '50%', marginRight: '8px' }}
                                                                        />
                                                                        <span className="account-email-sec" style={{ fontSize: '14px' }}> {account.email} <a className="remove-account-sync" onClick={() => handleRemoveGoogleAccount(account.account_id)}><img src={Delete} alt="Remove Account" className="remove-account-icon" style={{ width: '15px', height: '15px' }} /></a></span>
                                                                    </div>
                                                                ))}
                                                            </div> */}
                                                    </>
                                                )
                                            ) : (
                                                // <span>No account details available</span>
                                                null
                                            )}
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                        <a
                                            onClick={handleMoreGoogleCalendarToggle}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <img src={Add} alt="Add Account" className="add-account-icon" style={{ width: '15px', height: '15px' }} />
                                            Add Account
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* )}
                    {userSettingsData?.user_microsoft_calendar_enabled && ( */}
                    <div className="security-inner noti-enable security-inner-new">
                        <span className="custom-switch-description">
                            {global.config.locate(appSettings && appSettings.language, 'Connect_your_Microsoft_Calendar')}
                        </span>
                        <div className="accordion-right">
                            {userSettingsLoading === true ? (
                                <div className="button-sec-account" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                    <div
                                        style={{
                                            width: "120px",
                                            height: "20px",
                                            backgroundColor: "#e5e7eb",
                                            borderRadius: "4px",
                                            animation: "pulse 1.5s ease-in-out infinite",
                                        }}
                                    />
                                </div>
                            ) : (
                                <div className="button-sec-account">
                                    {isMicrosoftCalendarEnabled && (
                                        <div className="microsoft-account-email">
                                            {isMicrosoftAccountLoading ? (
                                                <div className="connected-to-new">
                                                    <div className="new-connect-wrapper">
                                                        <div
                                                            style={{
                                                                width: "200px",
                                                                height: "44px",
                                                                backgroundColor: "#e5e7eb",
                                                                borderRadius: "8px",
                                                                animation: "pulse 1.5s ease-in-out infinite",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            ) : microsoftAccountError ? (
                                                <span className="error-text">{microsoftAccountError}</span>
                                            ) : microsoftAccountEmail ? (
                                                // <span>Connected account: {microsoftAccountEmail}</span>
                                                microsoftAccountEmail?.length > 0 && (
                                                    <>
                                                        <div className="connected-to-new">
                                                            {microsoftAccountEmail.map((account, index) => (
                                                                <div key={index} className="new-connect-wrapper">
                                                                    <div className="new-connected">
                                                                        Connected to {account.email}
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                                                                            <path d="M1 4.5L5 8.5L12.5 1" stroke="#70AD69" strokeWidth="1.5" />
                                                                        </svg>
                                                                    </div>
                                                                    <div className="new-disconnect">
                                                                        <a
                                                                            className="remove-account-sync"
                                                                            onClick={() => handleRemoveMicrosoftAccount(account.account_id)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                                                                <path d="M13.7886 4.59619L4.59619 13.7886" stroke="#6A7988" strokeWidth="1.5" />
                                                                                <path d="M13.7886 13.7886L4.59619 4.59619" stroke="#6A7988" strokeWidth="1.5" />
                                                                            </svg>
                                                                            Disconnect
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {/* <div className="connect-label">Connected account:</div>
                                                            <div className="connected-microsoft-accounts">
                                                                {microsoftAccountEmail.map((account, index) => (
                                                                    <div key={`microsoft-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                                                        <img
                                                                            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
                                                                            alt={account.email}
                                                                            style={{ width: '24px', height: '24px', marginRight: '8px', borderRadius: '4px', backgroundColor: '#f1f1f1' }}
                                                                        />
                                                                        <span className="account-email-sec" style={{ fontSize: '14px' }}>{account.email} <a className="remove-account-sync" onClick={() => handleRemoveMicrosoftAccount(account.account_id)}><img src={Delete} alt="Remove Account" className="remove-account-icon" style={{ width: '15px', height: '15px' }} /></a></span>
                                                                    </div>
                                                                ))}
                                                            </div> */}
                                                    </>
                                                )
                                            ) : (
                                                // <span>No account details available</span>
                                                null
                                            )}
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                        <a
                                            onClick={handleMicrosoftCalendarToggle}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <img src={Add} alt="Add Account" className="add-account-icon" style={{ width: '15px', height: '15px' }} />
                                            Add Account
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* )} */}
                </div>
            )}
        </div>
    );
};

export default UserNotification;